import React from 'react'
import { useLocation } from 'react-router-dom'
import GovernanceContextHeader from './GovernanceContextHeader'
import InvestmentGovernanceProcessNav from './InvestmentGovernanceProcessNav'
import GovernanceDecisionJourney from '../../../components/governance_journey/GovernanceDecisionJourney.jsx'
import PageContent from '../../../components/shared/PageContent.jsx'

export default function GovernanceWorkspaceFrame({ children }) {
  const { pathname } = useLocation()
  const outcomeMeasurementOverview = pathname === '/benefits-governance'
  const boardDecisionsOverview = pathname === '/board-decisions'
  return <PageContent as="div" className="bg-slate-50">
    {outcomeMeasurementOverview && <header className="mb-5" data-testid="outcome-measurement-header">
      <p className="text-xs font-bold uppercase tracking-widest text-emerald-700">Outcome Governance</p>
      <h1 className="mt-1 text-3xl font-bold text-slate-950">Outcome Measurement</h1>
      <p className="mt-2 max-w-3xl text-slate-600">Evidence-based assessment of whether authorized digital risk investments are producing their expected outcomes.</p>
    </header>}
    {outcomeMeasurementOverview && <div className="mb-5"><GovernanceDecisionJourney currentStage="measure" /></div>}
    {boardDecisionsOverview && <header className="mb-5" data-testid="board-decisions-header">
      <p className="text-xs font-bold uppercase tracking-widest text-indigo-700">Executive Governance</p>
      <h1 className="mt-1 text-3xl font-bold text-slate-950">Board Decisions</h1>
      <p className="mt-2 max-w-3xl text-slate-600">Formal Board review and authorization of Management investment proposals.</p>
    </header>}
    <GovernanceContextHeader />
    <div className="mt-4 grid min-w-0 gap-4 lg:grid-cols-[14rem_minmax(0,1fr)] lg:items-start">
      <aside className="min-w-0 lg:sticky lg:top-4"><InvestmentGovernanceProcessNav /></aside>
      <div className="min-w-0">{children}</div>
    </div>
  </PageContent>
}
